import { onUnmounted, watch, type Ref } from 'vue';

export const SCROLL_LOCK_CLASS = 'wb-scroll-lock';

let isLocked = false;
let scrollTopBeforeLock = 0;

/**
 * Lock/unlock the scroll on the body element.
 * By adding the wb-scroll-lock class to the body element.
 * Adapted from https://git.i.mercedes-benz.com/dh-io-workbench/core/blob/develop/src/utils/services/scroll-lock.service.ts
 */
export function setScrollLock(lock: boolean): void {
  const el = document.documentElement;
  if (isLocked === lock) return;

  if (lock) {
    const scrollbarWidth = window.innerWidth - el.clientWidth;
    scrollTopBeforeLock = el.scrollTop;
    el.style.top = `-${scrollTopBeforeLock}px`;
    if (scrollbarWidth > 0) el.style.overflowY = 'scroll';
    el.classList.add(SCROLL_LOCK_CLASS);
  } else {
    el.classList.remove(SCROLL_LOCK_CLASS);
    el.style.top = '';
    el.style.overflowY = '';
    el.scrollTop = scrollTopBeforeLock;
  }
  isLocked = lock;
}

export function useScrollLock(isLockedRef: Ref<boolean>, immediate = false): void {
  watch(isLockedRef, setScrollLock, { immediate });
  onUnmounted(() => setScrollLock(false));
}
